export const isLatitude = (lat) => {
  return isFinite(lat) && Math.abs(lat) <= 90;
};

export const isLongitude = (lng) => {
  return isFinite(lng) && Math.abs(lng) <= 180;
};
